import { Briefcase, Compass, MessageSquare, Sparkles, User } from 'lucide-react';
import type { ComponentType, SVGProps } from 'react';
import { ROUTES } from '@/shared/config/constants';

export type NavItem = {
  label: string;
  to: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
};

export const NAV_ITEMS: NavItem[] = [
  { label: 'Matches', to: ROUTES.APP.MATCHES, icon: Compass },
  { label: 'Chat', to: ROUTES.APP.CHAT, icon: MessageSquare },
  { label: 'CRM', to: ROUTES.APP.CRM, icon: Briefcase },
  { label: 'Mentor', to: ROUTES.APP.MENTOR, icon: Sparkles },
  { label: 'Perfil', to: ROUTES.APP.PROFILE, icon: User },
];
